import { WordcloudTypes } from 'modules/admin-panel/pages/results/models';
// @ts-ignore
import variables from 'styles/_variables.scss';

export const getWordcloudColor = (wordcloudType: WordcloudTypes) => {
	switch (wordcloudType) {
		case WordcloudTypes.negative:
			return variables.dangerColor;
		case WordcloudTypes.neutral:
			return variables.mediumColor;
		case WordcloudTypes.positive:
			return variables.positiveColor;
	}
};
